export default {
  Title: 'Caregivers',
  Subtitle: 'Review profiles and select the perfect caregiver for your family',
  DefaultName: 'Caregiver',
  Client: 'Clients: #{names}',
  Languages: {
    Extra: '+#{count}',
  },
  YearsExperience: '• #{count} years of experience',
};
